import styled, {css} from 'styled-components';

import {mixins} from '@edna/components/styles';

export const ScrollUpButton = styled.button`
  ${mixins.position({position: 'fixed', right: '46px', bottom: '100px'})}
  ${mixins.wh('36px')};
  ${mixins.stack({align: 'center', justify: 'center'})}
  padding: 0;
  outline: none;
  cursor: pointer;
  opacity: 0.7;

  ${({theme}) => css`
    z-index: ${theme.zIndex.header};
    color: ${theme.palette.grey700};
    background-color: ${theme.palette.white};
    border: 2px solid ${theme.color.primary};
    border-radius: ${theme.borderRadius.br2};
    box-shadow: ${theme.boxShadow.default};
  `};
`;

export const ScrollDownButton = styled(ScrollUpButton)`
  ${mixins.position({position: 'absolute', right: '8px', bottom: '8px'})}
`;
